/* lfq1103-r3.js: L+F PDP round 3 edits 11/3. R196 + R215/R216: the study photo row takes the height of the slide on screen, so slides without a review leave no empty band. */
(function(){
 function ready(fn){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fn);else fn();}
 function study(){
  var vp=document.querySelector('#reviews .lfqa-study-vp');if(!vp||vp.dataset.lfr3Fit)return;vp.dataset.lfr3Fit='1';
  function fit(){var v=vp.getBoundingClientRect(),best=-1,h=0;[].forEach.call(vp.children,function(c){var r=c.getBoundingClientRect(),vis=Math.min(r.right,v.right)-Math.max(r.left,v.left);if(vis>best){best=vis;h=c.offsetHeight;}});
   if(!h)return;var cs=getComputedStyle(vp);if(cs.boxSizing==='border-box')h+=parseFloat(cs.paddingTop)+parseFloat(cs.paddingBottom);vp.style.height=h+'px';}
  var t;vp.addEventListener('scroll',function(){clearTimeout(t);t=setTimeout(fit,80);},{passive:true});
  window.addEventListener('resize',function(){setTimeout(fit,150);});
  [].forEach.call(vp.querySelectorAll('img'),function(i){if(!i.complete)i.addEventListener('load',fit,{once:true});});
  fit();setTimeout(fit,800);
 }
 /* R211: after the first video, Vidalytics starts the next one muted behind a "Click To Unmute" box, so the visitor had to tap twice.
    The visitor already tapped the tile, so press that box for them once and the video plays with sound. */
 function unmute(){
  var modal=document.getElementById('ugcVidModal');if(!modal||modal.dataset.lfr3Un)return;modal.dataset.lfr3Un='1';
  [].forEach.call(document.querySelectorAll('.ugc-cell[data-vdo]'),function(tile){
   tile.addEventListener('click',function(){var n=0,iv=setInterval(function(){n++;
    var box=modal.querySelector('.lfqa-vdo-box .bmpui-ui-vidalytics-unmute-overlay');
    if(box&&box.offsetWidth&&!box.dataset.lfr3){box.dataset.lfr3='1';box.click();clearInterval(iv);return;}
    var v=modal.querySelector('.lfqa-vdo-box video');if((v&&!v.paused&&!v.muted&&v.currentTime>1.5)||n>60||modal.hidden)clearInterval(iv);},250);});
  });
 }
 ready(function(){study();unmute();});
})();
